
export default {
  props: {
    submitButtonParams: {
      type: Object,
      default: {}
    }
  },

  methods: {
    submit: function submit() {
      this.$emit('submit');
    },
    back: function back() {
      window.history.back();
    }
  }
};